export function openExternalLink(url: string) {
	window.open(url, "_blank", "noopener,noreferrer");
}

export function downloadSvgById(svgId: string, filename: string) {
	const svgElement = document.getElementById(svgId);

	if (!(svgElement instanceof SVGSVGElement)) {
		throw new Error("QR code is not available for download");
	}

	const svgClone = svgElement.cloneNode(true);

	if (!(svgClone instanceof SVGSVGElement)) {
		throw new Error("Failed to prepare QR code for download");
	}

	if (!svgClone.getAttribute("xmlns")) {
		svgClone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
	}

	if (!svgClone.getAttribute("xmlns:xlink")) {
		svgClone.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
	}

	if (!svgClone.getAttribute("viewBox")) {
		const fallbackSize =
			svgElement.width.baseVal.value || svgElement.clientWidth || 208;
		svgClone.setAttribute("viewBox", `0 0 ${fallbackSize} ${fallbackSize}`);
	}

	if (!svgClone.getAttribute("width")) {
		svgClone.setAttribute("width", `${svgElement.width.baseVal.value}`);
	}

	if (!svgClone.getAttribute("height")) {
		svgClone.setAttribute("height", `${svgElement.height.baseVal.value}`);
	}

	const serializedSvg = new XMLSerializer().serializeToString(svgClone);
	const svgDocument = `<?xml version="1.0" encoding="UTF-8"?>\n${serializedSvg}`;

	const blob = new Blob([svgDocument], {
		type: "image/svg+xml;charset=utf-8",
	});
	const objectUrl = URL.createObjectURL(blob);
	const link = document.createElement("a");

	link.href = objectUrl;
	link.download = filename;
	document.body.append(link);
	link.click();
	link.remove();

	window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
}
